import React, { useState, useEffect } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { RiArrowRightSLine } from "react-icons/ri";
import { FiAlertCircle } from "react-icons/fi";
import { FaUserLarge } from "react-icons/fa6";
import { ImKey } from "react-icons/im";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { HiUserGroup } from "react-icons/hi";
import { Collapse } from "antd";
import "../../../App.css";
import EditProfile from "./EditProfile";
import ForgotPassword from "./ForgotPassword";
import { GetOperatorData } from "../../../Api/Settings/SystemSettings/CompanyDetails";
import { useDispatch, useSelector } from "react-redux";
import { FaKey } from "react-icons/fa";

export default function UserSettingList({active,setActive}) {

  // const [active, setActive] = useState("0");

  // const handleCollapseChange = (key) => {
  //   if (active !== key) {
  //     setActive(key);
  //   }
  // };
  // console.log(active, 'active_KEY');

  const [companyData, setCompanyData] = useState();
  const [userid, setUserid] = useState();
  const [selectedFile, setSelectedFile] = useState(null);


  const typeId = sessionStorage.getItem("type_id");
  const userID = sessionStorage.getItem("USER_ID")


  const operatorData = useSelector((state) => state?.crm?.operator_data[0])
  console.log(operatorData, 'operator_data')

  const dispatch = useDispatch()

  const fetchData = async () => {
    if (typeId === 'OP101') {
      try {
        const data = await GetOperatorData(dispatch)
        const profile = data[0].profileimg
        setSelectedFile(profile)
        console.log(profile, 'op_profile')
      } catch (error) {

      }
    }
  }

  useEffect(() => {
    fetchData()
  }, [dispatch]);

  // const [active, setActive] = useState("");

  const handleCollapseChange = (key) => {
    setActive((prev) => (prev === key ? "" : key));
  };

  console.log(active, 'active_KEY');

  

  return (
    <div>
      <Collapse
        activeKey={active}
        onChange={() => handleCollapseChange("4")}
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C]  shadow-xl"
        size="large"
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <IoIosArrowDown
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "4",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <FiAlertCircle
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Edit your details
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Change your details including name and email address
                  </p>
                </div>
              </div>
            ),
            children: <EditProfile />,
          },
        ]}
      />
      {/* <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] shadow-xl"
        size="large"
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <RiArrowRightSLine
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "1",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <FaUserLarge
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    User Management
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Add and edit users, manage your passwords
                  </p>
                </div>
              </div>
            ),
            children: <p className="p-[0.5vw]">User Management</p>,
          },
        ]}
      /> */}
      <Collapse
        activeKey={active}
        onChange={() => handleCollapseChange("5")}
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw]  shadow-xl"
        size="large"
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <IoIosArrowDown
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "5",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <ImKey
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.2vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Change Password
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Update your login password
                  </p>
                </div>
              </div>
            ),
            children: <ForgotPassword />,
          },
        ]}
      />
      {/* <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] shadow-xl"
        size="large"
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <RiArrowRightSLine
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "1",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <HiOutlineUserCircle
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[0.8vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    User Profiles
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Create and modify the user profiles that control security
                    and session timeout
                  </p>
                </div>
              </div>
            ),
            children: <p className="p-[0.5vw]">User Profiles</p>,
          },
        ]}
      /> */}
      {/* <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] shadow-xl"
        size="large"
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <RiArrowRightSLine
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "1",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <HiUserGroup
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    User Groups
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Create and modify the Groups that users ca belong to
                  </p>
                </div>
              </div>
            ),
            children: <p className="p-[0.5vw]">User Groups</p>,
          },
        ]}
      /> */}
    </div>
  );
}
